import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { organisationsQueryOptions } from '@/api/resources/organisations'
import { LoadingSpinner } from '@/components/feedback/loading-spinner'
import { PageHeader } from '@/components/layout/page-header'
import { ProductOrganisationCard } from '@/components/products/product-organisation-card'

export const Route = createFileRoute('/_app/products/')({
  head: () => ({ meta: [{ title: 'Products - MyJunea' }] }),
  component: ProductsIndexPage,
})

function ProductsIndexPage(): React.ReactElement {
  const { data: organisations, isLoading } = useQuery(organisationsQueryOptions())

  return (
    <div className="space-y-6">
      <PageHeader
        title="Products"
        description="View and manage product pricing across your machines."
      />

      {isLoading && <LoadingSpinner />}

      {!isLoading && (organisations === undefined || organisations.length === 0) && (
        <p className="text-muted-foreground py-10 text-center">No organisations found.</p>
      )}

      {organisations !== undefined && organisations.length > 0 && (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          {organisations.map((organisation) => (
            <Link
              key={organisation.id}
              to="/products/$organisationId"
              params={{ organisationId: String(organisation.id) }}
              className="focus-visible:ring-ring min-w-0 rounded-xl transition-transform hover:scale-[1.02] focus-visible:ring-2 focus-visible:outline-none"
            >
              <ProductOrganisationCard
                name={organisation.name}
                productsCount={organisation.products_count}
                className="h-full"
              />
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
